// The last few jukeboxes this browser opened, so a regular can get back to one without
// typing its code again. Kept on this device only; if storage is blocked it simply stays
// empty.

export interface RecentJukebox {
  code: string;
  name: string;
}

const KEY = 'recentJukeboxes';
export const MAX_RECENT = 3;

export const readRecentJukeboxes = (): RecentJukebox[] => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((entry) => entry && typeof entry.code === 'string' && typeof entry.name === 'string')
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
};

/** Puts this jukebox first, dropping any older entry for the same code. */
export const rememberJukebox = (code: string, name: string): RecentJukebox[] => {
  const entry = { code: code.toLowerCase(), name };
  const list = [entry, ...readRecentJukeboxes().filter((item) => item.code !== entry.code)].slice(0, MAX_RECENT);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // Private windows and blocked storage: nothing to remember, nothing broken.
  }
  return list;
};
